import axios  from "../../utils/axios";

export const create_staff = async (payload) => {
    const response = await axios.post(`/admin/staff`, payload);
    const {data} = response;

    return data;
};

export const get_all_staff = async () => {
    const response = await axios.get(`/admin/staff`);
    const {data} = response;

    return data;
};

export const get_staff = async (id) => {
    const response = await axios.get(`/admin/staff/${id}`);
    const {data} = response;

    return data;
};

export const delete_staff = async (id) => {
    const response = await axios.delete(`/admin/staff/${id}`, );
    const {data} = response;

    return data;
};

export const end_session = async (id) => {
    const response = await axios.delete(`/admin/session_staff/${id}`, );
    const {data} = response;

    return data;
};